import clsx from 'clsx';
import { fromEmpty } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import Button from '../../../../../../../../Form/Button';
import LearningCollectionEditStore from '../../../../../../Edit/Store';
import LearningDesignExperienceStore from '../../../../../../Experience/Store';
import { sectionContext } from '../../../../../../Types';
import { ExperienceResource } from '../../../../ExperienceCatalog/Types';

export interface Props {
  experienceResource: ExperienceResource;
  close: () => void;
  experienceStore: LearningDesignExperienceStore;
  store: LearningCollectionEditStore;
}

const onSubmit = (
  experienceStore: LearningDesignExperienceStore,
  store: LearningCollectionEditStore,
  experienceResource: ExperienceResource,
  close: () => void,
) => {
  fromEmpty(experienceStore.selectedIds)
    .do((ids) => {
      experienceStore.setSelectedIdsForAllLikeThis(ids, store.sections);
      experienceStore.setPreviouslySelectedIdsForAllLikeThis([], store.sections);
    })
    .elseDo(() => {
      experienceStore.setSelectedIdsForAllLikeThis(
        experienceStore.previouslySelectedIds,
        store.sections,
      );
      store.sections.forEach((section) =>
        store.removeExperienceStore(sectionContext(section), experienceResource),
      );
    });
  close();
};

const SubmitButton: React.FC<Props> = ({ experienceResource, close, experienceStore, store }) => (
  <div className="mt-12 flex items-center">
    <Button
      type="button"
      value="Save"
      onClick={() => onSubmit(experienceStore, store, experienceResource, close)}
      className={clsx(
        'mr-4 w-fit cursor-pointer rounded-lg bg-green-600',
        'px-5 py-2.5 text-sm font-light tracking-wide text-white hover:opacity-80',
      )}
    />
  </div>
);

export default observer(SubmitButton);
